import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

interface LongEventWarningModalProps {
  open: boolean;
  onEdit: () => void;
  onContinue: () => void;
}

const LongEventWarningModal: React.FC<LongEventWarningModalProps> = ({
  open,
  onEdit,
  onContinue,
}) => (
  <Dialog open={open} onClose={onEdit} fullWidth maxWidth="sm">
    <DialogTitle>Long Event Duration Warning</DialogTitle>
    <DialogContent>
      <p>Your event is over 12 hours long. Are you sure you want to continue?</p>
    </DialogContent>
    <DialogActions>
      <Button onClick={onEdit} color="primary">
        Edit
      </Button>
      <Button onClick={onContinue} color="primary" variant="contained">
        Yes, I&apos;m sure
      </Button>
    </DialogActions>
  </Dialog>
);

export default LongEventWarningModal;
